import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BlogList.css";
import dataEN from "../../../Data/BlogListEn";
import dataFR from "../../../Data/French/BlogListFr";
const ITEMS_PER_PAGE = 8;

export const BlogList = ({
  currentLanguage = "en",
  hidePagination = false,
  limit = null,
}) => {
  // ================= SELECT LANGUAGE =================
  const data = currentLanguage === "fr" ? dataFR : dataEN;
  const { blogs, readMore, prev, next } = data;
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(blogs.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;

  const visibleItems = limit
    ? blogs.slice(0, limit)
    : blogs.slice(startIndex, startIndex + ITEMS_PER_PAGE);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="container blog-container">
      <div className="row">
        {visibleItems.map((item) => (
          <div className="col-lg-3 col-md-6 col-sm-12" key={item.id}>
            <div className="blog-card">
              <img src={item.image} alt="" className="blog-img" />

              <div className="blog-content">
                <h4 className="blog-title">{item.title}</h4>

                {/* 
<p className="blog-meta">
  {item.author}{" "}
  <span style={{ color: "#6C757D" }}>
    — {item.date}
  </span>
</p> 
*/}

                <p className="blog-excerpt">{item.excerpt}</p>

                <a
                  onClick={() => {
                    navigate(`/blog-detail/${item.id}`);
                    window.location.reload();
                  }}
                  className="read-more"
                >
                  {readMore}{" "}
                  <img
                    src="/assets/images/Blog/bloglistarrow.png"
                    alt=""
                    width={15}
                  />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Pagination */}
      {!hidePagination && (
        <div className="pagination-box">
          <ul className="custom-pagination">
            <li
              className={`pag-item ${currentPage === 1 ? "disabled" : ""}`}
              onClick={() => goToPage(currentPage - 1)}
            >
              {prev}
            </li>

            {[1, 2, 3, 4, 5].map((page) => (
              <li
                key={page}
                className={`pag-item ${currentPage === page ? "active" : ""}`}
                onClick={() => goToPage(page)}
              >
                {page}
              </li>
            ))}

            <li className="pag-item dots">…</li>

            <li
              className={`pag-item ${
                currentPage === totalPages ? "active" : ""
              }`}
              onClick={() => goToPage(totalPages)}
            >
              {totalPages}
            </li>

            <li
              className={`pag-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
              onClick={() => goToPage(currentPage + 1)}
            >
              {next}
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};
